import React from 'react';
import styled from 'styled-components';
import { sectionMargins, standardColours } from '../styles';
import Banner from './Banner';
import FeaturedProductCategories from './FeaturedProductCategories';
import FeaturedProducts from './FeaturedProducts';

const StyledBannerFeaturedCategoriesProducts = styled.div`
  padding: 1px 0;
  background-color: ${standardColours.lightestGrey};
`;

const StyledFeaturedProductCategories = styled(FeaturedProductCategories)`
  ${sectionMargins('30px', '50px')};
`;

const StyledFeaturedProducts = styled(FeaturedProducts)`
  ${sectionMargins('30px', '50px')};
`;

const BannerFeaturedCategoriesProducts = ({
  banner,
  featuredCategories,
  featuredProducts,
}) => (
  <StyledBannerFeaturedCategoriesProducts>
    <Banner {...banner} />
    <StyledFeaturedProductCategories {...featuredCategories} alt={true} />
    <StyledFeaturedProducts {...featuredProducts} alt={true} />
  </StyledBannerFeaturedCategoriesProducts>
);

export default BannerFeaturedCategoriesProducts;
